import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarRange, faUser } from '@fortawesome/pro-regular-svg-icons';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { Body, Title } from '@e2n/ui/v2';
import { Location } from '@/domain/mitarbeiter/features/rotationsplan/components/Location';
import dayjs from 'dayjs';
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';

export function ArbeitsbereichStationInfo({
  station,
}: {
  station: ArbeitsbereichStation;
}) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <FontAwesomeIcon
            icon={faCircle}
            color={station.arbeitsbereich.getBorderColor()}
            className="size-2.5"
          />
          <Title>{station.arbeitsbereich.name}</Title>
        </div>
        {station.lernziele && station.lernziele.length > 0 && (
          <Body className="text-labels-secondary line-clamp-3">
            {station.lernziele}
          </Body>
        )}
      </div>
      <div className="flex flex-col items-start gap-1 text-labels-secondary">
        <div className="flex gap-1 items-center">
          <FontAwesomeIcon className="size-3.5" icon={faCalendarRange} />
          <Body className="text-labels-secondary" size="sm">
            {dayjs(station.von).format('DD.MM.YYYY') +
              ' - ' +
              dayjs(station.bis).format('DD.MM.YYYY')}
          </Body>
        </div>
        {station.abteilungsleiter && (
          <div className="flex gap-1 items-center">
            <FontAwesomeIcon className="size-3.5" icon={faUser} />
            <Body className="text-labels-secondary" size="sm">
              {station.abteilungsleiter.getName()}
            </Body>
          </div>
        )}
        <Location
          className="text-labels-secondary"
          standort={station.arbeitsbereich.standort}
        />
      </div>
    </div>
  );
}
